import { takeEvery } from 'redux-saga/effects';

import * as signInActions from 'store/modules/auth/signIn';
import { googleSignIn } from './utils';

export default function* listenGoogleSignIn() {
  yield takeEvery(signInActions.googleSignIn.toString(), googleSignIn);
}
